import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const FulfillmentTypeModal = ({ open, onClose, onSelect }) => {
  const handleOptionClick = (type) => {
    onSelect(type);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 2,
          maxWidth: '500px',
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        paddingBottom: 1,
        fontSize: '1.25rem',
        fontWeight: 500,
        color: '#333'
      }}>
        Choose Fulfillment Type
        <IconButton
          onClick={onClose}
          sx={{ 
            color: '#ff4444',
            '&:hover': {
              backgroundColor: 'rgba(255, 68, 68, 0.1)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ paddingTop: 2 }}>
        <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
          {/* Complete Fulfillment Option */}
          <Card
            sx={{
              flex: 1,
              cursor: 'pointer',
              border: '2px solid transparent',
              borderRadius: 3,
              transition: 'all 0.2s ease',
              '&:hover': {
                border: '2px solid #2196f3',
                boxShadow: '0 4px 12px rgba(33, 150, 243, 0.15)',
                transform: 'translateY(-2px)'
              },
              mt: 1
            }}
            onClick={() => handleOptionClick('complete')}
          >
            <CardContent sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              padding: '32px 24px !important',
              textAlign: 'center'
            }}>
              <Box sx={{ 
                position: 'relative',
                marginBottom: 3
              }}>
                <BookmarkIcon 
                  sx={{ 
                    fontSize: 48,
                    color: '#2196f3',
                    marginBottom: 1
                  }} 
                />
                <CheckCircleIcon
                  sx={{
                    fontSize: 24,
                    color: '#4caf50',
                    position: 'absolute',
                    bottom: -4,
                    right: -8,
                    backgroundColor: 'white',
                    borderRadius: '50%'
                  }}
                />
              </Box>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 500,
                  color: '#333',
                  fontSize: '1.1rem'
                }}
              >
                Complete Fulfillment
              </Typography>
            </CardContent>
          </Card>

          {/* Partial Fulfillment Option */}
          <Card
            sx={{
              flex: 1,
              cursor: 'pointer',
              border: '2px solid transparent',
              borderRadius: 3,
              transition: 'all 0.2s ease',
              '&:hover': {
                border: '2px solid #2196f3',
                boxShadow: '0 4px 12px rgba(33, 150, 243, 0.15)',
                transform: 'translateY(-2px)'
              },
              mt: 1
            }}
            onClick={() => handleOptionClick('partial')}
          >
            <CardContent sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              padding: '32px 24px !important',
              textAlign: 'center'
            }}>
              <Box sx={{ 
                position: 'relative',
                marginBottom: 3
              }}>
                <BookmarkIcon 
                  sx={{ 
                    fontSize: 48,
                    color: '#2196f3',
                    marginBottom: 1
                  }} 
                />
                <CheckCircleOutlineIcon
                  sx={{
                    fontSize: 24,
                    color: '#2196f3',
                    position: 'absolute',
                    bottom: -4,
                    right: -8,
                    backgroundColor: 'white',
                    borderRadius: '50%'
                  }}
                />
              </Box>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 500,
                  color: '#333',
                  fontSize: '1.1rem'
                }}
              >
                Partial Fulfillment
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FulfillmentTypeModal;